import { textStyle, wrapper } from './BetaTag.css';

export function BetaTag() {
  return (
    <div className={wrapper} aria-label="beta-tag">
      <span className={textStyle}>Beta</span>
    </div>
  );
}
